import { ActionPlanActivity } from './action-plan';

export const fingerprintActionItem = (
  activity: fhir.CarePlanActivity,
): string => {
  const actionPlan = new ActionPlanActivity(activity);
  const title = actionPlan.getTitle() ?? '';
  const notes = actionPlan.getDescription() ?? '';
  const system = actionPlan.getSystem() || 'general';
  return `${system}:${title}:${notes}`;
};

/**
 * Infer empty-run success from action items only (not impressions).
 * Something new landed when any post-run item was not present before the run.
 */
export const didNewActionItemsLand = (
  before: fhir.CarePlanActivity[] | undefined,
  after: fhir.CarePlanActivity[] | undefined,
): boolean => {
  const beforeSet = new Set((before ?? []).map(fingerprintActionItem));
  return (after ?? []).some(
    activity => !beforeSet.has(fingerprintActionItem(activity)),
  );
};
